<ng-content> </ng-content>
<div #anchor *ngIf="direction === 'down'" class="scroll-trigger">
  <div class="processing" *ngIf="isLoading"></div>
</div>
